<template>
<div id="category_details">
  <v-container>
    <v-row justify="center">
      <v-col md="8">
        <h1>Category Details</h1>

        <h2>Songs</h2>
        <v-data-table
          v-model="selectedSongs"
          :headers="headers"
          :items="songs"
          :page.sync="page"
          :options.sync="options"
          :server-items-length="totalCount"
          :loading="loading"
          :items-per-page="itemsPerPage"
          class="elevation-1"
          hide-default-footer
          :show-select="isAuthenticated"
          item-key="id"
          @page-count="pageCount = $event"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>

              <div
              v-if="selectedSongs.length !== 0"
              class="mx-2"
              >
                <SongAddToCategoriesDialog
                  :categories.sync="categories"
                  :selected-songs="selectedSongsIDs"
                  @done="selectedSongs = []"
                ></SongAddToCategoriesDialog>
              </div>

              <v-btn
                color="red darken-1"
                @click="detachSelectedSongs"
                v-if="selectedSongs.length !== 0"
              >Detach songs</v-btn>
            </v-toolbar>
          </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import apiClient from "@/utils/apiClient";
import SongAddToCategoriesDialog from "@/views/Songs/SongAddToCategoriesDialog"
import { mapGetters } from "vuex";

export default {
  name: "CategoryDetails",
  components: { SongAddToCategoriesDialog },
  data: () => ({
    songs: [],
    categories: [],
    headers: [
      {
        text: "Title",
        value: "title",
      },
      {
        text: "Performer",
        value: "performerName",
      },
    ],
    totalCount: 0,
    loading: false,
    options: {},
    page: 1,
    pageCount: 0,
    itemsPerPage: 30,
    selectedSongs: [],
  }),

  computed: {
    getSongsOptions() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options
      return {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
        categoryID: this.categoryID,
      };
    },

    categoryID() {
      return this.$route.params.categoryID
    },

    selectedSongsIDs() {
      return this.selectedSongs.map(x => x.id)
    },

    ...mapGetters("auth", ["isAuthenticated"])
  },

  watch: {
    options() {
      this.loadSongs()
    }
  },

  methods: {
    loadSongs() {
      this.loading = true
      apiClient
        .getSongs(this.getSongsOptions)
        .then((response) => {
          this.totalCount = response.data.totalCount;
          this.songs = response.data.items;
          this.loading = false
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
        })
    },

    detachSelectedSongs() {
      const object = {
        categories: [this.categoryID],
        songs: this.selectedSongs.map(x => x.id)
      }
      apiClient
        .deleteSongCategory(object)
        .then(() => {
          this.loadSongs()
        })
        .catch((error) => {
          console.log(error)
        })
    },

  },
}
</script>
